import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-container"
}
const _hoisted_2 = { class: "shift__title" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "datepicker-buttons" }
const _hoisted_6 = { class: "datepicker-buttons" }
const _hoisted_7 = { class: "form-row" }

import { ru } from "date-fns/locale";
import VitaButton from "@/components/UI/VitaButton.vue";
import VitaCheckbox from "@/components/UI/VitaCheckbox.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { computed, onMounted, ref } from 'vue';
import {
  addHours,
  addMonths,
  endOfMonth,
  format,
  isBefore,
  isValid,
  parse,
  startOfDay,
  startOfMonth,
  startOfToday,
} from "date-fns";
import store from "@/store";
import { checkUnsavedChanges } from "@/utils/main";
import { Vacation } from "@/types";

interface Props {
  date: string;
  zupGuid: string;
  pharmId: number;
  timezoneOffset: number;
  visible: boolean;
  updateId: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaVacationControl',
  props: {
    date: {},
    zupGuid: {},
    pharmId: {},
    timezoneOffset: {},
    visible: { type: Boolean },
    updateId: {}
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const onCloseClick = () => {
  confirmCloseModal.value = true;
};

const emit = __emit;

const closeVacationEdit = () => {
  emit("update:visible", false);
};

const isSingleDay = ref(false);
const confirmCloseModal = ref<boolean>(false);
const vacationDateFrom = ref<Date>(parse(props.date, "d.M.yyyy", new Date()));
const vacationDateTo = ref<Date | null>(null);
const inProcess = ref(false);

// Функция для форматирования отображаемой даты
const getFormattedDate = (date: Date | null, prefix: string) => {
  if (!date || !isValid(date)) return "";
  return `${prefix} ${format(date, "dd.MM.yyyy")}`;
};

// Форматированные даты
const formattedDateFrom = computed(() =>
  isSingleDay.value
    ? getFormattedDate(vacationDateFrom.value, "")
    : getFormattedDate(vacationDateFrom.value, "С")
);

const formattedDateTo = computed(() =>
  isSingleDay.value
    ? getFormattedDate(vacationDateTo.value, "")
    : getFormattedDate(vacationDateTo.value, "По")
);

// Минимальная дата: первое число текущего месяца
const minDate = computed(() => {
  const date = parse(props.date, 'd.M.yyyy', new Date())
  return startOfMonth(date)
})

// Максимальная дата: последнее число следующего месяца
const maxDate = computed(() => {
  const date = parse(props.date, 'd.M.yyyy', new Date())
  return endOfMonth(addMonths(date, 1))
})

// Отключаем прошедшие даты в календаре
const disablePastDates = (date: Date) =>
  isBefore(startOfDay(date), startOfToday());

// Проверка валидности выбранных дат
const isDateFromValid = computed(() => isValid(vacationDateFrom.value));

const isDateToValid = computed(() => isValid(vacationDateTo.value));

const dateFromPlaceholder = computed(() =>
  isSingleDay.value ? "__.__.____" : "С __.__.____"
);

const isPeriodValid = computed(() => {
  if (isSingleDay.value || !vacationDateTo.value) return true;
  return !isBefore(vacationDateTo.value, vacationDateFrom.value);
});

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const createVacation = async () => {
  if (!vacationDateFrom.value) return;

  // Не пришла вторая дата - устанавливаем на тот же день
  if (!vacationDateTo.value) {
    vacationDateTo.value = vacationDateFrom.value;
  }

  const dateFrom = addHours(
    vacationDateFrom.value,
    props.timezoneOffset
  ).toISOString();
  const dateTo = addHours(
    vacationDateTo.value,
    props.timezoneOffset
  ).toISOString();

  const vacationObj: Vacation = {
    pharmId: props.pharmId,
    zupGuid: props.zupGuid,
    dateFrom,
    dateTo,
  };

  const vacationUpdateObj = {
    pharmId: props.pharmId,
    id: props.updateId,
    zupGuid: props.zupGuid,
    dateFrom,
    dateTo,
  }

  try {
    inProcess.value = true;
    !loader.value ? store.commit("user/setLoader", true) : null;
    let statusCode: number;
    if (props.updateId) {
      statusCode = await store.dispatch("data/updateVacation", vacationUpdateObj);
    } else {
      statusCode = await store.dispatch("data/addVacation", vacationObj);
    }

    if (!isNaN(statusCode) && statusCode >= 400) return false;

    // Закрытие окна
    store.commit("data/closeCreateShift");

    // noinspection ES6MissingAwait
    store.dispatch("data/getFondWorkTime");
    // noinspection ES6MissingAwait
    store.dispatch("data/getFondWorkTimeHuman");
    await store.dispatch("data/getPharmSchedule");
    await store.dispatch("data/getAdminShift");
    // Обновление расписания для незаполненных дней
    await store.dispatch("data/getTimeScheduleDetails");
    await store.dispatch('data/getTimeSchedule')

    checkUnsavedChanges();
  } catch (e) {
    console.error(e);
  } finally {
    inProcess.value = false;
    store.commit("user/setLoader", false);
  }
};

onMounted(() => {
  if (props.updateId) isSingleDay.value = true;
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_vita_modal = _resolveComponent("vita-modal")!

  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.updateId ? 'Редактирование НН' : 'Проставление НН'), 1),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "form-label" }, "Период", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(VueDatePicker), {
              modelValue: vacationDateFrom.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vacationDateFrom).value = $event)),
              locale: "ru",
              "min-date": minDate.value,
              "max-date": maxDate.value,
              format: () => formattedDateFrom.value,
              placeholder: dateFromPlaceholder.value,
              "format-locale": _unref(ru),
              teleport: true,
              "enable-time-picker": false,
              "disabled-dates": disablePastDates,
              clearable: false,
              state: isDateFromValid.value && isPeriodValid.value,
              disabled: inProcess.value,
              "prevent-min-max-navigation": "",
              "data-qa": "vacation-control-datepicker-date-from"
            }, {
              "input-icon": _withCtx(() => [...(_cache[4] || (_cache[4] = []))]),
              "clear-icon": _withCtx(({ clear }) => [
                _createVNode(_component_vita_icon, {
                  onClick: clear,
                  name: "clear",
                  "data-qa": "vacation-control-icon-date-from-clear"
                }, null, 8, ["onClick"])
              ]),
              "action-row": _withCtx(({ closePicker, selectDate }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(VitaButton, {
                    width: "inline",
                    color: "muted",
                    class: "datepicker-btn",
                    onClick: closePicker,
                    "data-qa": "vacation-control-button-date-from-cancel"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Отмена", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(VitaButton, {
                    width: "inline",
                    class: "datepicker-btn",
                    onClick: selectDate,
                    "data-qa": "vacation-control-button-date-from-select"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Выбрать", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "min-date", "max-date", "format", "placeholder", "format-locale", "state", "disabled"]),
            (!isSingleDay.value)
              ? (_openBlock(), _createBlock(_unref(VueDatePicker), {
                  key: 0,
                  modelValue: vacationDateTo.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vacationDateTo).value = $event)),
                  locale: "ru",
                  "min-date": minDate.value,
                  "max-date": maxDate.value,
                  format: () => formattedDateTo.value,
                  placeholder: 'По __.__.____',
                  "start-date": _unref(parse)(props.date, 'd.M.yyyy', new Date()),
                  "format-locale": _unref(ru),
                  teleport: true,
                  "enable-time-picker": false,
                  "disabled-dates": disablePastDates,
                  clearable: true,
                  "prevent-min-max-navigation": "",
                  state: isDateToValid.value && isPeriodValid.value,
                  disabled: inProcess.value,
                  "data-qa": "vacation-control-datepicker-date-to"
                }, {
                  "input-icon": _withCtx(() => [...(_cache[7] || (_cache[7] = []))]),
                  "clear-icon": _withCtx(({ clear }) => [
                    _createVNode(_component_vita_icon, {
                      onClick: clear,
                      name: "clear",
                      "data-qa": "vacation-control-icon-date-to-clear"
                    }, null, 8, ["onClick"])
                  ]),
                  "action-row": _withCtx(({ closePicker, selectDate }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(VitaButton, {
                        width: "inline",
                        color: "muted",
                        class: "datepicker-btn",
                        onClick: closePicker,
                        "data-qa": "vacation-control-button-date-to-cancel"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Отмена", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(VitaButton, {
                        width: "inline",
                        class: "datepicker-btn",
                        onClick: selectDate,
                        "data-qa": "vacation-control-button-date-to-select"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Выбрать", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date", "max-date", "format", "start-date", "format-locale", "state", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({ 'date-error': true, 'is-shown': !isPeriodValid.value })
          }, " Укажите даты в правильном порядке ", 2),
          _createElementVNode("div", null, [
            _createVNode(VitaCheckbox, {
              modelValue: isSingleDay.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isSingleDay).value = $event)),
              id: "multiply-checkbox",
              label: "Проставить НН на один день",
              disabled: inProcess.value
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(VitaButton, {
              color: "muted",
              onClick: onCloseClick,
              disabled: inProcess.value,
              "data-qa": "vacation-control-button-close"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Отменить ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (confirmCloseModal.value)
              ? (_openBlock(), _createBlock(_component_vita_modal, {
                  key: 0,
                  title: "Вы уверены, что хотите отменить проставление НН?"
                }, {
                  default: _withCtx(() => [
                    _createVNode(VitaButton, {
                      color: "red",
                      width: "inline",
                      onClick: closeVacationEdit,
                      "data-qa": "vacation-control-button-close-confirm"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Да", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(VitaButton, {
                      color: "blue",
                      width: "inline",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmCloseModal.value = false)),
                      "data-qa": "vacation-control-button-close-reject"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Нет", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(VitaButton, {
              color: "blue",
              disabled: 
            inProcess.value ||
            (!isSingleDay.value && !isDateToValid.value) ||
            !isDateFromValid.value ||
            !isPeriodValid.value
          ,
              onClick: createVacation,
              "data-qa": "vacation-control-button-save"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Сохранить ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})